export var Resource;
(function (Resource) {
    Resource["Screen"] = "screens";
    Resource["Template"] = "templates";
    Resource["ScreenConfiguration"] = "screen-configuration";
    Resource["User"] = "users";
    Resource["Tenant"] = "tenants";
    Resource["Billing"] = "billing";
})(Resource || (Resource = {}));
